import { lenis } from './header.js';

const MAP_SELECTOR = '.js-full-width-map-all';

const MAPBOX_TOKEN = 'pk.eyJ1IjoianB3ZGVzaWducyIsImEiOiJjbG40bGZ0MjIwMTljMm1taXNtMWxqcHR2In0.3QMup5ho1rCVQDIK3O9i5w';
const MAP_STYLE = 'mapbox://styles/jpwdesigns/clnbzruta07tv01qbbcs3ghl6';
// Keep the initial overview centered on the active Southeast service area.
// At the desktop overview zoom below, location labels (which begin at zoom 5)
// remain hidden.
const SOUTHEAST_BOUNDS = [[-92, 24], [-73, 38]];

const CLUSTER_RADIUS = 55;
const MAP_MAX_ZOOM = 18;
const INITIAL_DESKTOP_ZOOM = 4.98;
const LABEL_MIN_ZOOM = 5;
const LABEL_FOCUS_ZOOM = 7;
const FOCUS_MAX_ZOOM = 16;
const SMALL_CLUSTER_LIMIT = 3;

const MOBILE_BREAKPOINT = 768;
const MOBILE_HEIGHT = 400;

const TEXT_FONT = ['DIN Pro Bold', 'Arial Unicode MS Bold'];
const TEXT_SIZE = 16;

const PILL_HEIGHT = 39;
const PILL_GLYPH_LEFT = 16;
const PILL_TEXT_LEFT = 45;
const PILL_TEXT_RIGHT = 20;
const PILL_WIDTH = 100;

const RING_WIDTH = 4;
const BEEP_GLYPH_SIZE = 18;
const FREEBEE_GLYPH_SIZE = 16;
const BADGE_SIZE = 30;
const BRAND_LANE_OFFSET = 34;

const BEEP_YELLOW = '#FFE600';
const BEEP_GREEN = '#004D2D';
const FREEBEE_INDIGO = '#3A4F85';
const WHITE = '#FFFFFF';

const LOCATION_ICON_PATH = '/assets/locations/';
// Must match the duration-300 utility on the drawer panel.
const DRAWER_DURATION = 300;
// Once the page is scrolled the mini header goes fixed at 3rem with a 5.7rem
// height, so keep the drawer we scroll to clear of it.
const DRAWER_SCROLL_OFFSET = 100;
// Below lg the directory is a single column, which is where an opened drawer can
// push its own summary out of view.
const DRAWER_BREAKPOINT = 1024;
const STATE_NAMES = {
	CA: 'California',
	FL: 'Florida',
	GA: 'Georgia',
	NC: 'North Carolina'
};
const STATE_ORDER = ['CA', 'FL', 'GA', 'NC'];
const FREEBEE_GROUP_ORDER = [
	'Miami-Dade',
	'Broward',
	'Palm Beach',
	'Treasure Coast',
	'Tampa Bay',
	'Central Florida',
	'Florida Keys',
	'Charlotte'
];
const FALLBACK_MENU_GROUPS = {
	'Broward': ['Deerfield Beach', 'Freebee HQ', 'Plantation', 'Sunrise', 'Tri-Rail - Cypress Creek Station'],
	'Palm Beach': ['Delray Beach', 'Green Cars for Kids - Palm Beach', 'Wellington'],
	'Treasure Coast': ['Fort Pierce', 'Tradition', 'Tradition - Fixed Route (T-Town)', 'Tradition - Fixed Route (Western Grove)'],
	'Tampa Bay': ['Bradenton-Palmetto', 'Dunedin', 'St. Pete Beach'],
	'Central Florida': ['Kissimmee', 'Lake Nona', 'Lake Nona - Fixed Route (Brightline)', 'Lake Nona - Fixed Route (Boxi Park)', 'Mount Dora', 'Seminole County - Scout'],
	'Florida Keys': ['Islamorada'],
	'Charlotte': ['Ballantyne Bolt', 'SouthPark Skipper']
};

const UNCLUSTERED_FILTER = ['!', ['has', 'point_count']];
const CLUSTER_FILTER = ['has', 'point_count'];

function glyphCentre(glyphSize) {
	return PILL_GLYPH_LEFT + glyphSize / 2;
}

function textOffsetEm(glyphSize) {
	return (PILL_TEXT_LEFT - glyphCentre(glyphSize)) / TEXT_SIZE;
}

function ring(outerSize) {
	return {
		radius: (outerSize - RING_WIDTH) / 2,
		path: outerSize - RING_WIDTH
	};
}

function pillSvg(glyph) {
	return '<svg xmlns="http://www.w3.org/2000/svg" width="' + (PILL_WIDTH * 2) + '" height="' + (PILL_HEIGHT * 2) + '">' +
		'<rect x="0" y="0" width="' + (PILL_WIDTH * 2) + '" height="' + (PILL_HEIGHT * 2) + '" rx="' + PILL_HEIGHT + '" fill="' + WHITE + '"/>' +
		glyph +
		'</svg>';
}

const BRANDS = {
	beep: {
		textColor: BEEP_GREEN,
		clusterImage: 'beep-cluster',
		pillImage: 'pill-beep',
		glyphSize: BEEP_GLYPH_SIZE,
		laneOffset: -BRAND_LANE_OFFSET,
		clusterSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="' + (BADGE_SIZE * 2) + '" height="' + (BADGE_SIZE * 2) + '">' +
			'<circle cx="' + BADGE_SIZE + '" cy="' + BADGE_SIZE + '" r="' + (ring(BADGE_SIZE).radius * 2) + '" fill="' + BEEP_YELLOW + '" stroke="' + BEEP_GREEN + '" stroke-width="' + (RING_WIDTH * 2) + '"/>' +
			'</svg>',
		pillSvg: pillSvg('<circle cx="' + (glyphCentre(BEEP_GLYPH_SIZE) * 2) + '" cy="' + PILL_HEIGHT + '" r="' + (ring(BEEP_GLYPH_SIZE).radius * 2) + '" fill="' + BEEP_YELLOW + '" stroke="' + BEEP_GREEN + '" stroke-width="' + (RING_WIDTH * 2) + '"/>')
	},
	freebee: {
		textColor: FREEBEE_INDIGO,
		clusterImage: 'freebee-cluster',
		pillImage: 'pill-freebee',
		glyphSize: FREEBEE_GLYPH_SIZE,
		laneOffset: BRAND_LANE_OFFSET,
		clusterSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="' + (BADGE_SIZE * 2) + '" height="' + (BADGE_SIZE * 2) + '">' +
			'<rect x="' + RING_WIDTH + '" y="' + RING_WIDTH + '" width="' + (ring(BADGE_SIZE).path * 2) + '" height="' + (ring(BADGE_SIZE).path * 2) + '" fill="' + WHITE + '" stroke="' + FREEBEE_INDIGO + '" stroke-width="' + (RING_WIDTH * 2) + '"/>' +
			'</svg>',
		pillSvg: pillSvg('<rect x="' + ((glyphCentre(FREEBEE_GLYPH_SIZE) - ring(FREEBEE_GLYPH_SIZE).path / 2) * 2) + '" y="' + ((PILL_HEIGHT / 2 - ring(FREEBEE_GLYPH_SIZE).path / 2) * 2) + '" width="' + (ring(FREEBEE_GLYPH_SIZE).path * 2) + '" height="' + (ring(FREEBEE_GLYPH_SIZE).path * 2) + '" fill="' + WHITE + '" stroke="' + FREEBEE_INDIGO + '" stroke-width="' + (RING_WIDTH * 2) + '"/>')
	}
};

function coordinateKey(coordinates) {
	return coordinates[0] + '|' + coordinates[1];
}

function normalise(raw) {
	const rows = Array.isArray(raw) ? raw : (raw && Array.isArray(raw.features) ? raw.features : []);
	const provisional = [];

	rows.forEach(function (row) {
		if (!row) { return; }

		let lng;
		let lat;
		let properties;

		if (row.geometry && Array.isArray(row.geometry.coordinates)) {
			lng = Number(row.geometry.coordinates[0]);
			lat = Number(row.geometry.coordinates[1]);
			properties = row.properties || {};
		} else {
			lng = Number(row.lng !== undefined ? row.lng : (row.lon !== undefined ? row.lon : row.longitude));
			lat = Number(row.lat !== undefined ? row.lat : row.latitude);
			properties = row;
		}

		if (!Number.isFinite(lng) || !Number.isFinite(lat)) { return; }

		const brand = String(properties.brand || '').trim().toLowerCase();
		if (!BRANDS[brand]) { return; }
		if (String(properties.status || '').trim().toLowerCase() === 'previous') { return; }

		const coordinates = [lng, lat];

		provisional.push({
			coordinates: coordinates,
			properties: properties,
			brand: brand
		});
	});

	const brandIds = { beep: 0, freebee: 0 };

	return provisional.map(function (item) {
		brandIds[item.brand] += 1;
		const original = item.properties;

		return {
			type: 'Feature',
			id: brandIds[item.brand],
			geometry: { type: 'Point', coordinates: item.coordinates },
			properties: {
				label: String(original.label || original.name || 'Location'),
				brand: item.brand,
				url: original.url ? String(original.url) : '',
				name: String(original.name || original.label || 'Location'),
				state: String(original.state || '').trim().toUpperCase(),
				status: String(original.status || ''),
				menuGroup: String(original.menuGroup || '')
			}
		};
	});
}

function createIcon(fileName, className) {
	const icon = document.createElement('img');
	icon.className = className;
	icon.src = LOCATION_ICON_PATH + fileName;
	icon.alt = '';
	icon.setAttribute('aria-hidden', 'true');
	return icon;
}

function orderedKeys(groups, preferredOrder) {
	return Object.keys(groups).sort(function (a, b) {
		const aIndex = preferredOrder.indexOf(a);
		const bIndex = preferredOrder.indexOf(b);
		if (aIndex === -1 && bIndex === -1) { return a.localeCompare(b); }
		if (aIndex === -1) { return 1; }
		if (bIndex === -1) { return -1; }
		return aIndex - bIndex;
	});
}

function fallbackMenuGroup(feature) {
	const properties = feature.properties;
	const name = properties.name;
	const matchingGroup = Object.keys(FALLBACK_MENU_GROUPS).find(function (group) {
		return FALLBACK_MENU_GROUPS[group].indexOf(name) !== -1;
	});
	if (matchingGroup) { return matchingGroup; }
	if (properties.state === 'FL') { return 'Miami-Dade'; }
	return '';
}

function groupByState(features) {
	return features.reduce(function (groups, feature) {
		const state = feature.properties.state || 'Other';
		if (!groups[state]) { groups[state] = []; }
		groups[state].push(feature);
		return groups;
	}, {});
}

function locationLink(feature, brand, compact, labelOverride) {
	const properties = feature.properties;
	const link = properties.url ? document.createElement('a') : document.createElement('span');
	const colorClass = brand === 'beep' ? 'text-beep-forrest-green' : 'text-freebee-indigo';
	link.className = compact
		? 'inline-block bg-transparent p-0 text-[2rem] leading-[1.2] font-bold no-underline text-freebee-indigo opacity-75 lg:text-[2.4rem]'
		: 'inline-block min-h-[6.7rem] bg-white p-[1.6rem] text-[2.4rem] leading-[2.7rem] font-bold no-underline focus-visible:outline focus-visible:outline-[.3rem] focus-visible:outline-offset-[.3rem] focus-visible:outline-beep-green lg:min-h-[7.8rem] lg:p-8 lg:text-[3.2rem] lg:leading-[3.4rem] ' + colorClass;
	link.textContent = labelOverride || properties.name;
	link.appendChild(createIcon(
		brand === 'beep' ? 'arrow-beep.svg' : (compact ? 'arrow-freebee-muted.svg' : 'arrow-freebee.svg'),
		'inline h-[1.6127rem] w-[1.6127rem] align-middle ' + (compact ? 'ml-4' : 'ml-6')
	));

	if (properties.url) {
		link.href = properties.url;
		if (/^https?:\/\//i.test(properties.url)) {
			link.target = '_blank';
			link.rel = 'noopener';
		}
	}

	return link;
}

function stateSection(state, features, brand) {
	const section = document.createElement('section');
	const heading = document.createElement('h3');
	const list = document.createElement('div');
	heading.className = brand === 'beep'
		? 'mb-5 text-[2rem] leading-none text-beep-forrest-green-tint font-bold lg:text-[2.4rem]'
		: 'mb-5 text-[2rem] leading-none text-freebee-indigo font-bold opacity-75 lg:text-[2.4rem]';
	heading.textContent = STATE_NAMES[state] || state;
	list.className = 'flex flex-col gap-5';
	features.forEach(function (feature) { list.appendChild(locationLink(feature, brand, false)); });
	section.appendChild(heading);
	section.appendChild(list);
	return section;
}

function drawerPanel(details) {
	return details.lastElementChild;
}

function updateDrawerIcon(details) {
	const open = details.dataset.drawer ? details.dataset.drawer === 'opening' : details.open;
	details.querySelector('summary img').src = LOCATION_ICON_PATH + (open ? 'accordion-minus.svg' : 'accordion-plus.svg');
}

function finishDrawer(details) {
	if (details.dataset.drawer === 'opening') {
		// Back to auto so the drawer reflows if its links re-wrap on resize.
		drawerPanel(details).style.height = 'auto';
	} else if (details.dataset.drawer === 'closing') {
		details.open = false;
	}
	delete details.dataset.drawer;
	updateDrawerIcon(details);
}

function animateDrawer(details, state, height) {
	const panel = drawerPanel(details);
	const style = getComputedStyle(panel);
	details.dataset.drawer = state;
	panel.style.height = height;
	updateDrawerIcon(details);
	// Reduced motion: no transitionend is coming, so land on the end state now.
	if (style.transitionProperty === 'none' || parseFloat(style.transitionDuration) === 0) {
		finishDrawer(details);
	}
}

function openDrawer(details) {
	details.open = true;
	// Reading scrollHeight flushes layout with the panel rendered but still
	// collapsed, which gives the transition a 0px value to start from.
	animateDrawer(details, 'opening', drawerPanel(details).scrollHeight + 'px');
}

function closeDrawer(details) {
	const panel = drawerPanel(details);
	panel.style.height = panel.scrollHeight + 'px'; // pin the auto height
	void panel.offsetHeight; // flush it so the collapse animates from a real value
	animateDrawer(details, 'closing', '0px');
}

function freebeeGroup(groupName, features) {
	if (features.length === 1) {
		return locationLink(features[0], 'freebee', false, groupName || features[0].properties.name.replace(/,\s*[A-Z]{2}$/, ''));
	}

	const details = document.createElement('details');
	const summary = document.createElement('summary');
	const title = document.createElement('span');
	const panel = document.createElement('div');
	const links = document.createElement('div');
	details.className = 'bg-white';
	summary.className = 'flex min-h-[6.7rem] cursor-pointer list-none items-center justify-between gap-6 p-[1.6rem] text-[2.4rem] leading-[2.7rem] text-freebee-indigo font-bold focus-visible:outline focus-visible:outline-[.3rem] focus-visible:outline-offset-[.3rem] focus-visible:outline-beep-green lg:min-h-[7.8rem] lg:p-8 lg:text-[3.2rem] lg:leading-[1.2]';
	title.textContent = groupName + ' (' + features.length + ')';
	// The padding lives on the inner div so the panel can animate from a true 0.
	panel.className = 'overflow-hidden transition-[height] duration-300 ease-out motion-reduce:transition-none';
	panel.style.height = '0px';
	links.className = 'flex flex-col gap-6 px-[1.6rem] pb-[1.6rem] lg:px-8 lg:pb-8';
	features.forEach(function (feature) { links.appendChild(locationLink(feature, 'freebee', true)); });
	summary.appendChild(title);
	summary.appendChild(createIcon('accordion-plus.svg', 'h-10 w-10 shrink-0'));
	panel.appendChild(links);
	details.appendChild(summary);
	details.appendChild(panel);

	panel.addEventListener('transitionend', function (event) {
		if (event.target === panel && event.propertyName === 'height') { finishDrawer(details); }
	});

	details.addEventListener('toggle', function () {
		// Something other than us opened it — find-in-page expands a closed details —
		// so match the panel to the new state instead of leaving it collapsed.
		if (details.dataset.drawer) { return; }
		panel.style.height = details.open ? 'auto' : '0px';
		updateDrawerIcon(details);
	});

	updateDrawerIcon(details);
	return details;
}

function collectionFor(features, brand) {
	return {
		type: 'FeatureCollection',
		features: features.filter(function (feature) {
			return feature.properties.brand === brand;
		})
	};
}

function addSvgImage(map, id, svg, width, height, options) {
	return new Promise(function (resolve) {
		const image = new Image();
		image.width = width;
		image.height = height;
		image.onload = function () {
			if (!map.hasImage(id)) { map.addImage(id, image, options); }
			resolve();
		};
		image.onerror = resolve;
		image.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
	});
}

function addBrandImages(map, brand) {
	const config = BRANDS[brand];
	const width = PILL_WIDTH * 2;
	const height = PILL_HEIGHT * 2;

	return Promise.all([
		addSvgImage(map, config.clusterImage, config.clusterSvg, BADGE_SIZE * 2, BADGE_SIZE * 2, { pixelRatio: 2 }),
		addSvgImage(map, config.pillImage, config.pillSvg, width, height, {
			pixelRatio: 2,
			stretchX: [[PILL_TEXT_LEFT * 2, width - PILL_TEXT_RIGHT * 2]],
			stretchY: [[PILL_HEIGHT - 10, PILL_HEIGHT + 10]],
			content: [PILL_TEXT_LEFT * 2, 0, width - PILL_TEXT_RIGHT * 2, height]
		})
	]);
}

function literalOffset(x, y) {
	return ['literal', [x, y]];
}

function clusterIconOffset(config) {
	return literalOffset(0, config.laneOffset);
}

function clusterTextOffset(config) {
	return literalOffset(0, config.laneOffset / TEXT_SIZE);
}

function singleIconOffset(config) {
	return literalOffset(0, config.laneOffset);
}

function singleTextOffset(config) {
	return literalOffset(0, config.laneOffset / TEXT_SIZE);
}

function pointTextOffset(config) {
	const base = textOffsetEm(config.glyphSize);
	return literalOffset(base, config.laneOffset / TEXT_SIZE);
}

function boundsForCoordinates(mapboxgl, coordinates) {
	if (!coordinates.length) { return null; }
	const bounds = new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]);
	coordinates.slice(1).forEach(function (coordinate) {
		bounds.extend(coordinate);
	});
	return bounds;
}

function coordinatesAreEqual(features) {
	if (features.length < 2) { return true; }
	const first = coordinateKey(features[0].geometry.coordinates);
	return features.every(function (feature) {
		return coordinateKey(feature.geometry.coordinates) === first;
	});
}

function boxesOverlap(a, b, margin) {
	return !(a.right + margin <= b.left || b.right + margin <= a.left || a.bottom + margin <= b.top || b.bottom + margin <= a.top);
}

class FullWidthMapAll {
	constructor(element, mapboxgl) {
		this.element = element;
		this.section = element.closest('.full-width-map');
		this.directory = element.dataset.directoryId ? document.getElementById(element.dataset.directoryId) : null;
		this.mapboxgl = mapboxgl;
		this.map = null;
		this.ready = false;
		this.layerActions = {};
		this.interactiveLayers = [];
		this.focusMarkers = [];
		this.interactionVersion = 0;
		this.programmaticMove = false;
		this.pendingResize = null;

		this.applyResponsiveHeight();
		this.createMap();
	}

	isMobile() {
		return window.innerWidth < MOBILE_BREAKPOINT;
	}

	initialPadding() {
		return this.isMobile() ? 24 : 56;
	}

	focusPadding() {
		return this.isMobile() ? 36 : 72;
	}

	duration() {
		return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500;
	}

	applyResponsiveHeight() {
		const height = this.isMobile() ? MOBILE_HEIGHT + 'px' : '';
		this.element.style.height = height;
		if (this.section) { this.section.style.height = height; }
	}

	createMap() {
		const mapboxgl = this.mapboxgl;
		mapboxgl.accessToken = MAPBOX_TOKEN;

		this.map = new mapboxgl.Map({
			container: this.element,
			style: MAP_STYLE,
			bounds: SOUTHEAST_BOUNDS,
			fitBoundsOptions: { padding: this.initialPadding(), duration: 0 },
			cooperativeGestures: true,
			maxZoom: MAP_MAX_ZOOM,
			projection: 'mercator'
		});
		if (!this.isMobile()) { this.map.setZoom(INITIAL_DESKTOP_ZOOM); }

		this.map.on('error', function (event) {
			console.error('[fullWidthMapAll] map error:', (event && event.error) || event);
		});

		this.map.addControl(new mapboxgl.NavigationControl({ showCompass: true }), 'top-right');

		this.bindLifecycleEvents();
		this.loadDataAndLayers();
	}

	bindLifecycleEvents() {
		const self = this;
		this.element.addEventListener('wheel', function (event) {
			if (!event.ctrlKey && !event.metaKey && !event.altKey) { return; }

			event.preventDefault();
			event.stopPropagation();
			document.dispatchEvent(new CustomEvent('full-width-map-all:wheel-zoom'));
		}, { passive: false });

		window.addEventListener('resize', function () {
			if (self.pendingResize) { return; }
			self.pendingResize = window.requestAnimationFrame(function () {
				self.pendingResize = null;
				self.applyResponsiveHeight();
				self.map.resize();
				if (self.focusMarkers.length) {
					window.requestAnimationFrame(function () { self.layoutFocusMarkers(); });
				}
			});
		});

		if (typeof ResizeObserver !== 'undefined') {
			new ResizeObserver(function () {
				self.map.resize();
			}).observe(this.element);
		}

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') { self.clearFocus(); }
		});

		this.map.on('dragstart', function () { self.clearFocus(); });
		this.map.on('rotatestart', function () { self.clearFocus(); });
		this.map.on('zoomstart', function () {
			if (!self.programmaticMove) { self.clearFocus(); }
		});
		this.map.on('zoomend', function () {
			console.info('[fullWidthMapAll] zoom:', self.map.getZoom().toFixed(2));
		});
	}

	loadDataAndLayers() {
		const self = this;
		const dataReady = fetch(this.element.dataset.locationsSrc)
			.then(function (response) {
				if (!response.ok) { throw new Error('Locations file returned ' + response.status); }
				return response.json();
			})
			.then(normalise)
			.then(function (features) {
				self.renderDirectory(features);
				return features;
			})
			.catch(function (error) {
				console.error('[fullWidthMapAll] could not load locations:', error);
				if (self.directory) { self.directory.hidden = true; }
				return [];
			});

		this.whenStyleReady(function () {
			Promise.all([
				dataReady,
				addBrandImages(self.map, 'beep'),
				addBrandImages(self.map, 'freebee')
			]).then(function (results) {
				const features = results[0];
				if (!features.length) { return; }

				Object.keys(BRANDS).forEach(function (brand) {
					self.addBrandSource(brand, collectionFor(features, brand));
				});

				self.addAllLayers();
				self.bindMapInteractions();
				self.ready = true;
				console.info('[fullWidthMapAll] zoom:', self.map.getZoom().toFixed(2));
			}).catch(function (error) {
				console.error('[fullWidthMapAll] could not build map layers:', error);
			});

			self.map.resize();
		});
	}

	renderDirectory(features) {
		if (!this.directory) { return; }
		const beepList = this.directory.querySelector('[data-location-list="beep"]');
		const freebeeList = this.directory.querySelector('[data-location-list="freebee"]');
		if (!beepList || !freebeeList) { return; }

		const beepStates = groupByState(features.filter(function (feature) {
			return feature.properties.brand === 'beep';
		}));
		orderedKeys(beepStates, STATE_ORDER).forEach(function (state) {
			beepList.appendChild(stateSection(state, beepStates[state], 'beep'));
		});

		const freebeeFeatures = features.filter(function (feature) {
			return feature.properties.brand === 'freebee';
		});
		const useFallbackGroups = !freebeeFeatures.some(function (feature) {
			return feature.properties.menuGroup;
		});
		const freebeeStates = groupByState(freebeeFeatures);
		orderedKeys(freebeeStates, ['FL', 'NC']).forEach(function (state) {
			const groups = {};
			freebeeStates[state].forEach(function (feature) {
				const fallbackGroup = useFallbackGroups ? fallbackMenuGroup(feature) : '';
				const group = feature.properties.menuGroup || fallbackGroup || feature.properties.name.replace(/,\s*[A-Z]{2}$/, '');
				if (!groups[group]) { groups[group] = []; }
				groups[group].push(feature);
			});

			const section = document.createElement('section');
			const heading = document.createElement('h3');
			const list = document.createElement('div');
			heading.className = 'mb-5 text-[2rem] leading-none text-freebee-indigo font-bold opacity-75 lg:text-[2.4rem]';
			heading.textContent = STATE_NAMES[state] || state;
			list.className = 'flex flex-col gap-5';
			orderedKeys(groups, FREEBEE_GROUP_ORDER).forEach(function (group) {
				list.appendChild(freebeeGroup(group, groups[group]));
			});
			section.appendChild(heading);
			section.appendChild(list);
			freebeeList.appendChild(section);
		});

		freebeeList.addEventListener('click', function (event) {
			const summary = event.target.closest('summary');
			if (!summary) { return; }
			// Take the toggle over from the browser so the panel height can animate.
			event.preventDefault();

			const details = summary.parentElement;
			if (details.open && details.dataset.drawer !== 'closing') {
				closeDrawer(details);
				return;
			}

			// Captured before anything collapses: where this drawer sits now, and how
			// far it travels up once the open drawers above it close.
			const top = details.getBoundingClientRect().top + window.scrollY;
			let shift = 0;

			freebeeList.querySelectorAll('details[open]').forEach(function (other) {
				if (other === details || other.dataset.drawer === 'closing') { return; }
				if (other.compareDocumentPosition(details) & Node.DOCUMENT_POSITION_FOLLOWING) {
					shift += drawerPanel(other).offsetHeight;
				}
				closeDrawer(other);
			});

			openDrawer(details);

			// Lenis owns scrollTop every frame, so a native scrollIntoView would be
			// undone by its next tick — the scroll has to go through Lenis.
			if (window.innerWidth < DRAWER_BREAKPOINT) {
				lenis.scrollTo(Math.max(top - shift - DRAWER_SCROLL_OFFSET, 0), {
					duration: DRAWER_DURATION / 1000
				});
			}
		});
	}

	whenStyleReady(callback) {
		if (this.map.isStyleLoaded()) {
			callback();
			return;
		}
		this.map.once('style.load', callback);
	}

	addBrandSource(brand, collection) {
		this.map.addSource('locations-' + brand, {
			type: 'geojson',
			data: collection,
			cluster: true,
			clusterMaxZoom: MAP_MAX_ZOOM,
			clusterRadius: CLUSTER_RADIUS
		});
	}

	addAllLayers() {
		const self = this;
		Object.keys(BRANDS).forEach(function (brand) { self.addSingleLayer(brand); });
		Object.keys(BRANDS).forEach(function (brand) { self.addPointLayer(brand); });
		Object.keys(BRANDS).forEach(function (brand) { self.addClusterLayer(brand); });
	}

	registerLayer(id, brand, type) {
		this.layerActions[id] = { brand: brand, type: type };
		this.interactiveLayers.push(id);
	}

	addSingleLayer(brand) {
		const config = BRANDS[brand];
		const id = brand + '-singles';
		this.map.addLayer({
			id: id,
			type: 'symbol',
			source: 'locations-' + brand,
			filter: UNCLUSTERED_FILTER,
			layout: {
				'icon-image': config.clusterImage,
				'icon-offset': singleIconOffset(config),
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
				'text-field': '1',
				'text-font': TEXT_FONT,
				'text-size': TEXT_SIZE,
				'text-offset': singleTextOffset(config),
				'text-allow-overlap': true,
				'text-ignore-placement': true
			},
			paint: { 'text-color': config.textColor }
		});
		this.registerLayer(id, brand, 'single');
	}

	addPointLayer(brand) {
		const config = BRANDS[brand];
		const id = brand + '-points';
		this.map.addLayer({
			id: id,
			type: 'symbol',
			source: 'locations-' + brand,
			filter: UNCLUSTERED_FILTER,
			minzoom: LABEL_MIN_ZOOM,
			layout: {
				'icon-image': config.pillImage,
				'icon-text-fit': 'width',
				'icon-text-fit-padding': [0, 0, 0, 0],
				'text-field': ['get', 'label'],
				'text-font': TEXT_FONT,
				'text-size': TEXT_SIZE,
				'text-max-width': 30,
				'text-anchor': 'left',
				'text-offset': pointTextOffset(config)
			},
			paint: { 'text-color': config.textColor }
		});
		this.registerLayer(id, brand, 'point');
	}

	addClusterLayer(brand) {
		const config = BRANDS[brand];
		const id = brand + '-clusters';
		this.map.addLayer({
			id: id,
			type: 'symbol',
			source: 'locations-' + brand,
			filter: CLUSTER_FILTER,
			layout: {
				'icon-image': config.clusterImage,
				'icon-offset': clusterIconOffset(config),
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
				'text-field': ['get', 'point_count_abbreviated'],
				'text-font': TEXT_FONT,
				'text-size': TEXT_SIZE,
				'text-offset': clusterTextOffset(config),
				'text-allow-overlap': true,
				'text-ignore-placement': true
			},
			paint: { 'text-color': config.textColor }
		});
		this.registerLayer(id, brand, 'cluster');
	}

	bindMapInteractions() {
		const self = this;

		this.map.on('click', function (event) {
			const features = self.map.queryRenderedFeatures(event.point, { layers: self.interactiveLayers });
			if (!features.length) {
				self.clearFocus();
				return;
			}

			const feature = features[0];
			const action = self.layerActions[feature.layer.id];
			if (!action) { return; }

			if (action.type === 'cluster') {
				self.handleClusterClick(action.brand, feature);
			} else if (action.type === 'single') {
				self.focusLeaves([feature]);
			} else {
				self.navigate(feature.properties.url);
			}
		});

		this.map.on('mousemove', function (event) {
			const features = self.map.queryRenderedFeatures(event.point, { layers: self.interactiveLayers });
			self.map.getCanvas().style.cursor = features.length ? 'pointer' : '';
		});

		this.map.getCanvas().addEventListener('mouseleave', function () {
			self.map.getCanvas().style.cursor = '';
		});
	}

	navigate(url) {
		if (!url) { return; }
		if (/^https?:\/\//i.test(url)) {
			window.open(url, '_blank', 'noopener');
		} else {
			window.location.href = url;
		}
	}

	getClusterLeaves(source, clusterId, limit) {
		return new Promise(function (resolve, reject) {
			source.getClusterLeaves(clusterId, limit, 0, function (error, leaves) {
				if (error) { reject(error); return; }
				resolve(leaves || []);
			});
		});
	}

	async handleClusterClick(brand, feature) {
		this.clearFocus();
		const version = this.interactionVersion;
		const source = this.map.getSource('locations-' + brand);
		const clusterId = feature.properties.cluster_id;
		const count = Number(feature.properties.point_count) || 0;

		try {
			if (count <= SMALL_CLUSTER_LIMIT) {
				const leaves = await this.getClusterLeaves(source, clusterId, count);
				if (version === this.interactionVersion) { this.focusLeaves(leaves, version); }
				return;
			}

			const leaves = await this.getClusterLeaves(source, clusterId, count);
			if (version !== this.interactionVersion) { return; }
			if (!leaves.length) { return; }

			const coordinates = leaves.map(function (leaf) { return leaf.geometry.coordinates; });
			if (coordinatesAreEqual(leaves)) {
				const targetZoom = Math.min(MAP_MAX_ZOOM, this.map.getZoom() + 2);
				this.performCamera(function (map, duration) {
					map.easeTo({ center: coordinates[0], zoom: targetZoom, duration: duration });
				});
				return;
			}

			const bounds = boundsForCoordinates(this.mapboxgl, coordinates);
			const self = this;

			this.performCamera(function (map, duration) {
				map.fitBounds(bounds, {
					padding: self.focusPadding(),
					maxZoom: FOCUS_MAX_ZOOM,
					duration: duration
				});
			});
		} catch (error) {
			console.error('[fullWidthMapAll] could not expand cluster:', error);
		}
	}

	focusLeaves(leaves, existingVersion) {
		if (!leaves || !leaves.length) { return; }
		if (existingVersion === undefined) {
			this.clearFocus();
			existingVersion = this.interactionVersion;
		}

		const self = this;
		const coordinates = leaves.map(function (leaf) { return leaf.geometry.coordinates; });
		const bounds = boundsForCoordinates(this.mapboxgl, coordinates);
		const sameCoordinate = coordinatesAreEqual(leaves);

		this.excludeFocusedFeatures(leaves);

		if (sameCoordinate) {
			const extraZoom = leaves.length > 1 ? 2 : 0;
			const targetZoom = Math.min(MAP_MAX_ZOOM, Math.max(this.map.getZoom() + extraZoom, LABEL_FOCUS_ZOOM));
			this.performCamera(function (map, duration) {
				map.easeTo({ center: coordinates[0], zoom: targetZoom, duration: duration });
			}, function () {
				if (existingVersion === self.interactionVersion) { self.showFocusMarkers(leaves, existingVersion); }
			});
			return;
		}

		this.performCamera(function (map, duration) {
			map.fitBounds(bounds, {
				padding: self.focusPadding(),
				maxZoom: FOCUS_MAX_ZOOM,
				duration: duration
			});
		}, function () {
			if (existingVersion === self.interactionVersion) { self.showFocusMarkers(leaves, existingVersion); }
		});
	}

	performCamera(action, callback) {
		const self = this;
		let finished = false;

		function finish() {
			if (finished) { return; }
			finished = true;
			self.map.off('moveend', finish);
			self.programmaticMove = false;
			if (callback) { callback(); }
		}

		this.programmaticMove = true;
		this.map.once('moveend', finish);
		action(this.map, this.duration());

		window.requestAnimationFrame(function () {
			if (!self.map.isMoving()) { finish(); }
		});
	}

	excludeFocusedFeatures(leaves) {
		const idsByBrand = { beep: [], freebee: [] };
		leaves.forEach(function (leaf) {
			const brand = leaf.properties.brand;
			if (idsByBrand[brand] && leaf.id !== undefined) { idsByBrand[brand].push(leaf.id); }
		});

		Object.keys(BRANDS).forEach(function (brand) {
			const ids = idsByBrand[brand];
			if (!ids.length) { return; }
			const filter = ['all', UNCLUSTERED_FILTER, ['!', ['in', ['id'], ['literal', ids]]]];
			this.map.setFilter(brand + '-singles', filter);
			this.map.setFilter(brand + '-points', filter);
		}, this);
	}

	async hideFocusedClusters(leaves, version) {
		const focusedIds = { beep: {}, freebee: {} };
		leaves.forEach(function (leaf) {
			if (focusedIds[leaf.properties.brand]) {
				focusedIds[leaf.properties.brand][String(leaf.id)] = true;
			}
		});

		await Promise.all(Object.keys(BRANDS).map(async function (brand) {
			if (!Object.keys(focusedIds[brand]).length) { return; }
			const layerId = brand + '-clusters';
			const source = this.map.getSource('locations-' + brand);
			const rendered = this.map.queryRenderedFeatures({ layers: [layerId] });
			const clusters = {};

			rendered.forEach(function (feature) {
				const clusterId = feature.properties.cluster_id;
				if (clusterId !== undefined) { clusters[String(clusterId)] = feature; }
			});

			const hiddenIds = [];
			await Promise.all(Object.keys(clusters).map(async function (key) {
				const cluster = clusters[key];
				const count = Number(cluster.properties.point_count) || 0;
				const clusterLeaves = await this.getClusterLeaves(source, cluster.properties.cluster_id, count);
				if (clusterLeaves.length && clusterLeaves.every(function (leaf) {
					return focusedIds[brand][String(leaf.id)];
				})) {
					hiddenIds.push(cluster.properties.cluster_id);
				}
			}, this));

			if (version !== this.interactionVersion || !hiddenIds.length) { return; }
			this.map.setFilter(layerId, [
				'all',
				CLUSTER_FILTER,
				['!', ['in', ['get', 'cluster_id'], ['literal', hiddenIds]]]
			]);
		}, this));
	}

	async showFocusMarkers(leaves, version) {
		try {
			await this.hideFocusedClusters(leaves, version);
		} catch (error) {
			console.error('[fullWidthMapAll] could not hide focused subclusters:', error);
		}
		if (version !== this.interactionVersion) { return; }

		const self = this;
		leaves.forEach(function (feature) {
			const brand = feature.properties.brand;
			const config = BRANDS[brand];
			const wrapper = document.createElement('div');
			const connector = document.createElement('span');
			const pill = feature.properties.url ? document.createElement('a') : document.createElement('span');
			const glyph = document.createElement('span');
			const text = document.createElement('span');

			wrapper.className = 'map-location-focus-marker';
			connector.className = 'map-location-focus-marker__connector';
			connector.style.backgroundColor = config.textColor;
			pill.className = 'map-location-focus-marker__pill map-location-focus-marker__pill--' + brand;
			glyph.className = 'map-location-focus-marker__glyph';
			text.className = 'map-location-focus-marker__text';
			text.textContent = feature.properties.label;

			if (feature.properties.url) {
				pill.href = feature.properties.url;
				if (/^https?:\/\//i.test(feature.properties.url)) {
					pill.target = '_blank';
					pill.rel = 'noopener';
				}
				pill.addEventListener('click', function (event) { event.stopPropagation(); });
			}

			pill.appendChild(glyph);
			pill.appendChild(text);
			wrapper.appendChild(connector);
			wrapper.appendChild(pill);

			const marker = new self.mapboxgl.Marker({ element: wrapper, anchor: 'center' })
				.setLngLat(feature.geometry.coordinates)
				.addTo(self.map);

			self.focusMarkers.push({
				marker: marker,
				wrapper: wrapper,
				connector: connector,
				pill: pill,
				feature: feature,
				config: config
			});
		});

		window.requestAnimationFrame(function () { self.layoutFocusMarkers(); });
	}

	layoutFocusMarkers() {
		if (!this.focusMarkers.length) { return; }
		const width = this.element.clientWidth;
		const height = this.element.clientHeight;
		const margin = this.isMobile() ? 12 : 18;
		const gap = 8;
		const groups = {};
		const placedBoxes = [];

		const entries = this.focusMarkers.map(function (entry) {
			const point = this.map.project(entry.feature.geometry.coordinates);
			const rect = entry.pill.getBoundingClientRect();
			const glyph = glyphCentre(entry.config.glyphSize);
			return Object.assign(entry, {
				point: point,
				width: rect.width,
				height: rect.height,
				glyphCentre: glyph
			});
		}, this);

		entries.forEach(function (entry) {
			const key = coordinateKey(entry.feature.geometry.coordinates);
			if (!groups[key]) { groups[key] = []; }
			groups[key].push(entry);
		});

		const groupedEntries = Object.keys(groups).map(function (key) { return groups[key]; });
		groupedEntries.sort(function (a, b) { return b.length - a.length; });

		groupedEntries.forEach(function (group) {
			if (group.length > 1) {
				this.layoutCoincidentFocusMarkers(group, width, height, margin, gap, placedBoxes);
				return;
			}
			this.layoutSingleFocusMarker(group[0], width, height, margin, gap, placedBoxes);
		}, this);
	}

	layoutCoincidentFocusMarkers(entries, width, height, margin, gap, placedBoxes) {
		entries.sort(function (a, b) {
			return String(a.feature.properties.label).localeCompare(String(b.feature.properties.label));
		});

		const point = entries[0].point;
		const maxWidth = Math.max.apply(null, entries.map(function (entry) { return entry.width; }));
		const totalHeight = entries.reduce(function (sum, entry) { return sum + entry.height; }, 0) + gap * (entries.length - 1);
		const roomOnRight = width - point.x;
		const roomOnLeft = point.x;
		const placeRight = roomOnRight >= maxWidth + 64 || roomOnRight >= roomOnLeft;
		const pillLeft = placeRight
			? Math.min(width - maxWidth - margin, Math.max(margin, point.x + 48))
			: Math.max(margin, Math.min(width - maxWidth - margin, point.x - maxWidth - 48));
		const startY = Math.max(margin, Math.min(height - totalHeight - margin, point.y - totalHeight / 2));
		let nextY = startY;

		entries.forEach(function (entry) {
			const targetGlyphX = pillLeft + entry.glyphCentre;
			const targetY = nextY + entry.height / 2;
			const offsetX = targetGlyphX - entry.point.x;
			const offsetY = targetY - entry.point.y;
			this.positionFocusMarker(entry, offsetX, offsetY);
			placedBoxes.push(this.focusBox(entry, offsetX, offsetY));
			nextY += entry.height + gap;
		}, this);
	}

	layoutSingleFocusMarker(entry, width, height, margin, gap, placedBoxes) {
		const step = entry.height + gap;
		const candidates = [0, -step, step, -step * 2, step * 2, -step * 3, step * 3];
		let chosen = null;

		for (let i = 0; i < candidates.length; i += 1) {
			const offset = this.clampFocusOffset(entry, 0, candidates[i], width, height, margin);
			const box = this.focusBox(entry, offset.x, offset.y);
			if (!placedBoxes.some(function (placed) { return boxesOverlap(box, placed, gap); })) {
				chosen = { offset: offset, box: box };
				break;
			}
		}

		if (!chosen) {
			const offset = this.clampFocusOffset(entry, 0, 0, width, height, margin);
			chosen = { offset: offset, box: this.focusBox(entry, offset.x, offset.y) };
		}

		this.positionFocusMarker(entry, chosen.offset.x, chosen.offset.y);
		placedBoxes.push(chosen.box);
	}

	clampFocusOffset(entry, offsetX, offsetY, width, height, margin) {
		const box = this.focusBox(entry, offsetX, offsetY);
		let x = offsetX;
		let y = offsetY;

		if (box.left < margin) { x += margin - box.left; }
		if (box.right > width - margin) { x -= box.right - (width - margin); }
		if (box.top < margin) { y += margin - box.top; }
		if (box.bottom > height - margin) { y -= box.bottom - (height - margin); }

		return { x: x, y: y };
	}

	focusBox(entry, offsetX, offsetY) {
		return {
			left: entry.point.x - entry.glyphCentre + offsetX,
			right: entry.point.x - entry.glyphCentre + offsetX + entry.width,
			top: entry.point.y - entry.height / 2 + offsetY,
			bottom: entry.point.y + entry.height / 2 + offsetY
		};
	}

	positionFocusMarker(entry, offsetX, offsetY) {
		entry.pill.style.transform = 'translate(' + (offsetX - entry.glyphCentre) + 'px, ' + (offsetY - entry.height / 2) + 'px)';
		const length = Math.sqrt(offsetX * offsetX + offsetY * offsetY);

		if (length < 2) {
			entry.connector.style.display = 'none';
			return;
		}

		entry.connector.style.display = '';
		entry.connector.style.width = length + 'px';
		entry.connector.style.transform = 'rotate(' + Math.atan2(offsetY, offsetX) + 'rad)';
	}

	clearFocus() {
		this.interactionVersion += 1;
		this.focusMarkers.forEach(function (entry) { entry.marker.remove(); });
		this.focusMarkers = [];

		if (!this.ready) { return; }
		Object.keys(BRANDS).forEach(function (brand) {
			this.map.setFilter(brand + '-singles', UNCLUSTERED_FILTER);
			this.map.setFilter(brand + '-points', UNCLUSTERED_FILTER);
			this.map.setFilter(brand + '-clusters', CLUSTER_FILTER);
		}, this);
	}
}

function initFullWidthMaps() {
	if (!window.mapboxgl) { return; }
	document.querySelectorAll(MAP_SELECTOR).forEach(function (element) {
		if (element.dataset.mapInitialised === 'true') { return; }
		element.dataset.mapInitialised = 'true';
		new FullWidthMapAll(element, window.mapboxgl);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initFullWidthMaps);
} else {
	initFullWidthMaps();
}
